if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.hideErrors = this.dataset.hideErrors === 'true';
    }
    async onSubmitHandler(event) {
      event.preventDefault();
      const button = this.form.querySelector('[type="submit"]');
      if (!button || button.disabled || this.submitting) return;
      this.submitting = true;
      button.disabled = true;
      button.classList.add('loading');
      button.setAttribute('aria-busy', 'true');
      this.handleErrorMessage();
      const cart = document.querySelector('cart-notification');
      const cartItems = document.querySelector('cart-items');
      const quickView = document.getElementById('quickViewWrapper');
      let added = false;
      try {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const data = new FormData(this.form);
        const sectionIds = new Set();
        if (cart) {
          cart.getSectionsToRender().forEach(section => sectionIds.add(section.id));
          cart.setActiveElement(document.activeElement);
        }
        if (cartItems) cartItems.getSectionsToRender().forEach(section => sectionIds.add(section.section));
        if (sectionIds.size) data.set('sections', Array.from(sectionIds).join(','));
        data.set('sections_url', window.location.pathname);
        config.body = data;
        const response = await fetch(window.routes.cart_add_url, config);
        const state = await response.json();
        if (!response.ok || state.status) {
          this.handleErrorMessage(state.description || state.message || window.cartStrings.error);
          return;
        }
        added = true;
        // A successful add must not be presented as a failed request if drawer rendering fails.
        try {
          if (cartItems) cartItems.renderContents(state);
          else if (cart) cart.renderContents(state);
          else window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
        } catch (error) {
          window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
        }
      } catch (error) {
        this.handleErrorMessage(window.cartStrings.networkError || window.cartStrings.error);
      } finally {
        button.classList.remove('loading');
        button.removeAttribute('aria-busy');
        button.disabled = false;
        this.submitting = false;
        if (added && quickView?.classList.contains('show__modal')) {
          quickView.classList.remove('show__modal');
          // The cart drawer controls its own body lock.
          if (!cart || cartItems) document.body.classList.remove('overflow-hidden');
        }
      }
    }
    handleErrorMessage(message = '') {
      if (this.hideErrors) return;
      let wrapper = this.querySelector('.product-form__error-message-wrapper');
      if (!wrapper && message) {
        wrapper = document.createElement('div');
        wrapper.className = 'product-form__error-message-wrapper';
        wrapper.setAttribute('role', 'alert');
        const text = document.createElement('span');
        text.className = 'product-form__error-message';
        wrapper.append(text);
        this.form.append(wrapper);
      }
      if (!wrapper) return;
      wrapper.hidden = !message;
      wrapper.classList.remove('no-js-inline');
      const text = wrapper.querySelector('.product-form__error-message');
      if (text) text.textContent = message;
    }
  });
}
